import { Field, FieldProps } from 'formik';
import { FC, useState } from 'react';
import cn from 'classnames';
import styles from './InfluencerCostField.module.css';

const InfluencerCostField: FC<{ name: string; currencySymbol: '$' | '£' | '€' }> = ({ name, currencySymbol }) => {
    const [isFocused, setIsFocused] = useState(false);
    return (
        <Field name={name} type="number">
            {({ field }: FieldProps) => (
                <div
                    className={cn(styles.wrapper, { [styles.isFocused]: isFocused })}
                    onBlurCapture={() => setIsFocused(false)}
                >
                    {currencySymbol}
                    <input
                        type="number"
                        {...field}
                        className={styles.input}
                        onClick={() => setIsFocused(true)}
                        onBlurCapture={() => setIsFocused(false)}
                    />
                </div>
            )}
        </Field>
    );
};

export default InfluencerCostField;
